import React from 'react';
import { heroData } from '../data/mock';

const Header = () => {
  return (
    <header className="w-full bg-white relative z-50">
      {/* Main Header with Hero Text */}
      <div className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
          <div className="flex flex-col items-center text-center">
            {/* Hero Text Centered */}
            <div className="max-w-4xl">
              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-4 leading-tight italic">
                {heroData.title}
              </h1>
              <p className="text-base md:text-lg text-gray-600 mb-6">
                {heroData.subtitle}
              </p>
              <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200 text-left">
                <p className="text-gray-800 text-base md:text-lg font-semibold italic mb-4 leading-relaxed">
                  What If You Could Pre-Position Yourself in Front of the Booming AI-Driven Wellness Intelligence Tech Revolution… And Build Residual Income Before the Masses Even Catch On
                </p>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                  Imagine being part of the early team behind <strong>Apple</strong>, <strong>Oura Ring</strong>, or <strong>Fitbit</strong> - before the world caught on. That's what Prism iO is offering: a first-mover opportunity to build leveraged, residual income from breakthrough wellness tech powered by AI. No inventory, no overhead, no capital - just your time, leadership, and a system that scales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
